var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgPrevStep = function SvgPrevStep(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.7071 6.29289C20.0976 6.68342 20.0976 7.31658 19.7071 7.70711L15.4142 12L19.7071 16.2929C20.0976 16.6834 20.0976 17.3166 19.7071 17.7071C19.3166 18.0976 18.6834 18.0976 18.2929 17.7071L13.2929 12.7071C12.9024 12.3166 12.9024 11.6834 13.2929 11.2929L18.2929 6.29289C18.6834 5.90237 19.3166 5.90237 19.7071 6.29289Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 14C4.11744 13.1174 3.67615 12.6762 3.62737 12.1346C3.6193 12.045 3.6193 11.955 3.62737 11.8654C3.67615 11.3238 4.11744 10.8826 5 10C5.88256 9.11744 6.32385 8.67615 6.86543 8.62737C6.95496 8.6193 7.04504 8.6193 7.13457 8.62737C7.67615 8.67615 8.11744 9.11744 9 10C9.88256 10.8826 10.3238 11.3238 10.3726 11.8654C10.3807 11.955 10.3807 12.045 10.3726 12.1346C10.3238 12.6762 9.88256 13.1174 9 14C8.11744 14.8826 7.67615 15.3238 7.13457 15.3726C7.04504 15.3807 6.95496 15.3807 6.86543 15.3726C6.32385 15.3238 5.88256 14.8826 5 14Z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPrevStep);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "prev-step.ed4b4a26f678d59e9d670537116cacde.svg";